import styled from "styled-components";

export const SearchPCIconBoxDefault = styled.i`
    display: block;
    position: absolute;
    top: 50%;
    left: 0.35rem;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    background-position: -138px -626px;
    z-index: 2;
    pointer-events: none;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        left: 0.15rem;
        transform: scale(0.9) translateY(-55%);
    }

`;